import React from 'react';
import { ResellerType } from './AdminResellerStats';
import AdminResellerStatsRow from './AdminResellerStatsRow';
import { AdminResellerStatsData } from './AdminResellerStats';

interface AdminResellerStatsTableProps {
  stats: AdminResellerStatsData[];
  commissionSettings: {
    totalCommission: number;
    supportCommissionToMainAssociation: number;
    supportCommissionToAssociation: number;
  };
  bookletId?: string;
  onPaidOutUpdate: (resellerId: string, resellerType: ResellerType, amount: number) => void;
}

const AdminResellerStatsTable: React.FC<AdminResellerStatsTableProps> = ({ stats, commissionSettings, onPaidOutUpdate }) => {
  return (
    <div className="reseller-stats-table">
      <div className="table-header">
        <span>Förening / Sålda</span>
        <span>Uppgifter</span>
        <span>Period</span>
        <span>ÅF:s förtjänst</span>
        <span>HF:s förtjänst</span>
        <span>Utbetalt</span>
      </div>
      <div className="table-body">
        {stats.map((stat) => (
          <AdminResellerStatsRow
            key={stat.resellerId}
            stats={stat}
            commissionSettings={commissionSettings}
            onPaidOutUpdate={onPaidOutUpdate}
          />
        ))}
      </div>
    </div>
  );
};

export default AdminResellerStatsTable;
